import { SeriesFunction } from '../../';

const _ = require('lodash');


function averageSeries({series = null}) {
  let indices = series.getIndices();
  let values = series.getValues().filter(v => v !== null);
  
  let mean = _.mean(values);
  let newData = _.zip(indices, indices.map(_ => mean));

  return new series.constructor(newData);
}

export const average = new SeriesFunction(
  averageSeries,
  {
    label: 'Average a Series',
    description: 'average(series)',
    parameters: [
      {'name': 'series', 'type': 'series'}
    ],
    maxLength: 1
  }
);